import { useQuery } from '@tanstack/react-query';
import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi';

export function useGetQuestionnaireIdsByFacilityId(facilityId: number | undefined, enabled: boolean = true) {
    return useQuery<number[]>({
        queryKey: ['questionnaireIdsByFacilityId', facilityId],
        queryFn: () => facilityId ? HealthcareFacilitiesApi.getQuestionnaireIdsByFacilityId(facilityId) : Promise.resolve([]),
        enabled: enabled && facilityId !== undefined && facilityId > 0,
    });
}
